import { ValidationResult } from "lib/hooks/use-input";

import { isFinite, isNumber } from "lodash";

export const numberValidator = (v: number): ValidationResult => {
  const value = parseInt(v.toString());

  if (!isNumber(value) || !isFinite(value)) {
    return {
      valid: false,
      message: "Please enter a valid number",
    };
  }
  return { valid: true };
};
